import { Facebook, Instagram, Linkedin, Youtube, ArrowUp } from "lucide-react";
import { Link } from "react-router-dom";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_industrial-shields/artifacts/otud2dwa_Flexi.png";

const SOCIALS = [
  { Icon: Facebook, href: "https://www.facebook.com/GuardaFlex/?locale=es_LA", label: "Facebook" },
  { Icon: Instagram, href: "https://www.instagram.com/guardaflex/?hl=es", label: "Instagram" },
  { Icon: Linkedin, href: "https://www.linkedin.com/in/guardaflex", label: "LinkedIn" },
  // { Icon: Youtube, href: "#", label: "YouTube" },
];

export default function Footer() {
  const goTop = () =>
    window.scrollTo({ top: 0, behavior: "smooth" });

  const goTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer
      data-testid="footer"
      className="bg-[#061226] text-white relative overflow-hidden"
    >
      <div className="absolute top-0 inset-x-0 h-px bg-gradient-to-r from-transparent via-[#00B4D8]/60 to-transparent" />

      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 lg:py-20">
        <div className="grid lg:grid-cols-12 gap-10 mb-14">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-4 mb-5">
              <div className="inline-block bg-white px-3 py-2" style={{ borderRadius: "2px" }}>
                <img
                  src={LOGO_URL}
                  alt="Guarda Flex"
                  className="h-12 w-auto"
                />
              </div>
              <span className="font-display font-black text-2xl tracking-tight leading-none">
                <span className="text-white">GUARDA</span>
                <span className="text-slate-400"> FLEX</span>
                <sup className="ml-0.5 text-xs font-bold text-slate-400">™</sup>
              </span>
            </div>
            <p className="text-white/65 text-sm leading-relaxed max-w-md mb-6">
              Soluciones inmediatas para que tu producción no se detenga.
              Fabricación, reparación y mantenimiento de sistemas de
              protección para maquinaria CNC.
            </p>
            <div className="flex items-center gap-3">
              {SOCIALS.map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`social-link-${s.label.toLowerCase()}`}
                  className="w-10 h-10 border border-white/15 flex items-center justify-center text-white/70 hover:border-[#00B4D8] hover:text-[#00B4D8] transition-colors"
                  aria-label={s.label}
                >
                  <s.Icon size={16} />
                </a>
              ))}
            </div>
          </div>

          <div className="lg:col-span-2">
            <div className="font-mono-accent text-[10px] uppercase tracking-[0.25em] text-[#00B4D8] mb-4">
              Navegación
            </div>
            <ul className="space-y-3 text-sm">
              {[
                { id: "inicio", l: "Inicio" },
                { id: "nosotros", l: "Nosotros" },
                { id: "servicios", l: "Servicios" },
                { id: "galeria", l: "Galería" },
                { id: "contacto", l: "Contacto" },
              ].map((i) => (
                <li key={i.id}>
                  <button
                    onClick={() => goTo(i.id)}
                    className="text-white/70 hover:text-[#00B4D8] transition-colors"
                  >
                    {i.l}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <div className="font-mono-accent text-[10px] uppercase tracking-[0.25em] text-[#00B4D8] mb-4">
              Servicios
            </div>
            <ul className="space-y-3 text-sm text-white/70">
              <li>Fabricación</li>
              <li>Reparación</li>
              <li>Mantenimiento</li>
              <li>Asesoría técnica</li>
            </ul>
          </div>

          <div className="lg:col-span-3">
            <div className="font-mono-accent text-[10px] uppercase tracking-[0.25em] text-[#00B4D8] mb-4">
              Contacto directo
            </div>
            <ul className="space-y-3 text-sm text-white/70">
              <li>442 431 9100</li>
              <li>contacto@guardaflex.com.mx</li>
              <li>Querétaro, QRO., México</li>
              <li>Cobertura: Querétaro local</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="text-white/50 text-xs">
            © {new Date().getFullYear()} Guarda Flex. Todos los derechos
            reservados.
          </p>
          <div className="flex items-center gap-6 text-xs text-white/50">
            <Link
              to="/aviso-de-privacidad"
              data-testid="footer-privacy-link"
              className="hover:text-[#00B4D8] transition-colors"
            >
              Aviso de privacidad
            </Link>
            <a href="#" className="hover:text-[#00B4D8] transition-colors">
              Términos
            </a>
            <button
              onClick={goTop}
              data-testid="footer-go-top"
              className="flex items-center gap-2 hover:text-[#00B4D8] transition-colors"
            >
              Volver arriba <ArrowUp size={12} />
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}
